module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABAElEQVR4AWOgC/gPBrdfftNtOMmQuhcNadWdAEpB1MA0wMC3X3+jZl9BVh0+68rnH38gsggN3pMuIItO2POILXM/c/q+3l0P4YJABYHTLkE1AE1SqT529dkXuPSJex+O3fkA5954/lW99jhQGUIDEPHkHFhx6sV/DLDu3CugFEQNQgMcrTrzEln1xguvoVKYGjiz9s85/BTThqUnXwCl0DXIlR898+ATXNHFx5/PPkRwLz35DPQkQoNr//m3X37BpYH2AI0EBtS0A0/ggh++/QYGJlTDn7//IKI/f/9NW3wd2dGxc68CIwc9HiCch2+/m7Wdxoxpg6aT917DYnpQAgBMoVHgUQJydwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_scotland.png
// module id = 1321
// module chunks = 0